import { useEffect, useState } from "react";
import { getLang } from "../lib/i18n";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";
import { QuoteDocument } from "../components/QuoteDocument";

export default function QuotePrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [q, setQ] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    api.get(`/quotes/${id}`).then((r) => {
      setQ(r.data);
      if (r.data.client_id) {
        api.get("/clients").then((c) => {
          const lang = c.data.find((x) => x.id === r.data.client_id)?.lang === "en" ? "en" : "fr";
          if (lang !== getLang()) window.location.replace(`${window.location.pathname}?lang=${lang}`);
        }).catch(() => {});
      }
    });
    api.get("/company").then((r) => setCompany(r.data));
  }, [id]);

  if (!q || !company) return null;
  return (
    <div className="min-h-screen bg-slate-100 py-8">
      <div className="no-print mx-auto mb-4 flex max-w-3xl justify-between px-4">
        <Button variant="ghost" data-testid="print-back-button" onClick={() => navigate(-1)}><ArrowLeft className="mr-2 h-4 w-4" />Retour</Button>
        <Button data-testid="print-button" className="bg-[#0b2c6b]" onClick={() => window.print()}><Printer className="mr-2 h-4 w-4" />Imprimer / PDF</Button>
      </div>
      <QuoteDocument q={q} company={company} />
    </div>
  );
}
